function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  stroke: "#999",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  transform: "translate(-33.000000, -742.000000) translate(0.000000, 726.000000) translate(0.000000, 4.000000) translate(33.000000, 12.000000) translate(4.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 18v-2c0-2.21-1.79-4-4-4H4c-2.21 0-4 1.79-4 4v2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 4,
  r: 4
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-33.000000, -742.000000) translate(0.000000, 726.000000) translate(0.000000, 4.000000) translate(33.000000, 12.000000)"
}))))));

function SvgProfileDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDefault);
export default __webpack_public_path__ + "static/media/profile_default.62291a56.svg";
export { ForwardRef as ReactComponent };